import { c as _c } from "react/compiler-runtime";
import React from "react";
import { getLiveFerryStartDate, getLiveFerryTripHref } from "./liveFerryTrip";
import { getFerryDisplayName } from "./vehicleDisplay";
const currentStatusTranslator = currentStatus => {
  switch (currentStatus) {
    case "INCOMING_AT":
      return "arriving at";
    case "STOPPED_AT":
      return "stopped at";
    case "IN_TRANSIT_TO":
      return "to";
    default:
      return "to";
  }
};
function getAucklandFerryName(ferry) {
  return ferry?.vehicleLabel || ferry?.licensePlate || ferry?.vehicleId || ferry?.routeShortName || "Ferry";
}
function normalizeFerryTrip(ferry, {
  stopNameById = {}
} = {}) {
  if (ferry?.trip?.tripId) {
    const stopId = ferry.stopId;
    return {
      key: ferry.trip.tripId,
      tripId: ferry.trip.tripId,
      startDate: getLiveFerryStartDate(ferry.trip.startDate),
      vehicleName: getFerryDisplayName(ferry.vehicle),
      currentStatus: ferry.currentStatus,
      stopName: stopNameById[stopId] || stopId,
      routeId: ferry.trip.routeId,
      routeShortName: ferry.routeShortName || ferry.trip.routeId,
      routeType: ferry.routeType ?? 4
    };
  }
  if (ferry?.tripId) {
    return {
      key: `${ferry.vehicleId || "ferry"}-${ferry.tripId}`,
      tripId: ferry.tripId,
      startDate: getLiveFerryStartDate(ferry.startDate),
      vehicleName: getAucklandFerryName(ferry),
      currentStatus: ferry.currentStatus,
      stopName: ferry.nextStopName || ferry.currentStopName,
      routeId: ferry.routeId,
      routeShortName: ferry.routeShortName,
      routeType: ferry.routeType ?? 4
    };
  }
  return null;
}
function normalizeFerryTrips(liveFerries, options) {
  const rawTrips = Array.isArray(liveFerries) ? liveFerries : Array.isArray(liveFerries?.vessels) ? liveFerries.vessels : [];
  return rawTrips.map(ferry => normalizeFerryTrip(ferry, options)).filter(ferry => ferry?.tripId);
}
function LiveFerryRouteMark(t0) {
  const $ = _c(7);
  const {
    ferry,
    FerryIcon,
    RouteBadgeComponent
  } = t0;
  if (RouteBadgeComponent && ferry.routeShortName) {
    let t1;
    if ($[0] !== RouteBadgeComponent || $[1] !== ferry.routeId || $[2] !== ferry.routeShortName || $[3] !== ferry.routeType) {
      t1 = <RouteBadgeComponent className="h-8 w-8" routeLabel={ferry.routeShortName} route_short_name={ferry.routeShortName} route_type={ferry.routeType} service_id={ferry.routeId} />;
      $[0] = RouteBadgeComponent;
      $[1] = ferry.routeId;
      $[2] = ferry.routeShortName;
      $[3] = ferry.routeType;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (FerryIcon) {
    let t1;
    if ($[5] !== FerryIcon) {
      t1 = <FerryIcon className="h-[1.125rem] w-[1.125rem] text-blue-600 dark:text-blue-400" />;
      $[5] = FerryIcon;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  return null;
}
function LiveFerryRow(t0) {
  const $ = _c(21);
  const {
    ferry,
    FerryIcon,
    LinkComponent: t1,
    RouteBadgeComponent
  } = t0;
  const LinkComponent = t1 === undefined ? "a" : t1;
  let t2;
  if ($[0] !== ferry) {
    t2 = getLiveFerryTripHref(ferry);
    $[0] = ferry;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const href = t2;
  const LinkTag = LinkComponent;
  let t3;
  if ($[2] !== FerryIcon || $[3] !== RouteBadgeComponent || $[4] !== ferry) {
    t3 = <div className="mr-2 grid h-8 w-9 flex-shrink-0 place-items-center pl-1"><LiveFerryRouteMark ferry={ferry} FerryIcon={FerryIcon} RouteBadgeComponent={RouteBadgeComponent} /></div>;
    $[2] = FerryIcon;
    $[3] = RouteBadgeComponent;
    $[4] = ferry;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ferry.vehicleName) {
    t4 = <span className="font-medium">{ferry.vehicleName}</span>;
    $[6] = ferry.vehicleName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ferry.currentStatus || $[9] !== ferry.stopName) {
    t5 = ferry.stopName ? <>{" "}{currentStatusTranslator(ferry.currentStatus)}{" "}<span className="inline-block">{ferry.stopName}</span></> : " live now";
    $[8] = ferry.currentStatus;
    $[9] = ferry.stopName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex w-full"><div className="pt-1">{t4}{t5}</div></div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex w-full items-start">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== LinkTag || $[18] !== href || $[19] !== t7) {
    t8 = <LinkTag href={href} className="transition-colors flex flex-nowrap items-start px-[20px] py-5 text-lg leading-tight outline-none ring-blue-500/50 duration-150 hover:bg-zinc-400/10 focus-visible:ring focus-visible:ring-inset active:bg-zinc-400/10 sm:rounded-lg">{t7}</LinkTag>;
    $[17] = LinkTag;
    $[18] = href;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export default function LiveFerryUpdates(t0) {
  const $ = _c(22);
  const {
    liveFerries,
    isLoading,
    isValidating,
    loadingLabel: t1,
    emptyLabel: t2,
    errorLabel: t3,
    title: t4,
    stopNameById,
    FerryIcon,
    SpinnerIcon,
    LinkComponent,
    RouteBadgeComponent
  } = t0;
  const loadingLabel = t1 === undefined ? "Loading..." : t1;
  const emptyLabel = t2 === undefined ? "No ferries currently sailing." : t2;
  const errorLabel = t3 === undefined ? "Live ferry trips are not available right now." : t3;
  const title = t4 === undefined ? "Live Updates" : t4;
  let t5;
  if ($[0] !== FerryIcon || $[1] !== LinkComponent || $[2] !== RouteBadgeComponent || $[3] !== SpinnerIcon || $[4] !== emptyLabel || $[5] !== errorLabel || $[6] !== isLoading || $[7] !== isValidating || $[8] !== liveFerries || $[9] !== loadingLabel || $[10] !== stopNameById || $[11] !== title) {
    const trips = normalizeFerryTrips(liveFerries, {
      stopNameById
    });
    const message = liveFerries?.message;
    const hasError = Boolean(liveFerries?.error);
    let t6;
    if ($[13] !== title) {
      t6 = <h2 className="mb-3 text-3xl font-semibold">{title}</h2>;
      $[13] = title;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== SpinnerIcon || $[16] !== isLoading || $[17] !== isValidating) {
      t7 = SpinnerIcon ? <div className="ml-1 grid h-9 w-9 place-items-center"><SpinnerIcon className={`h-[1.375rem] w-[1.375rem] animate-spin text-blue-600 transition-opacity duration-300 dark:text-blue-400 ${isValidating && !isLoading ? "opacity-100" : "opacity-0"}`} /></div> : null;
      $[15] = SpinnerIcon;
      $[16] = isLoading;
      $[17] = isValidating;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== t6 || $[20] !== t7) {
      t8 = <div className="flex px-[20px]">{t6}{t7}</div>;
      $[19] = t6;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t5 = <div className="mb-2 py-4 text-lg">{t8}{isLoading ? <div className="mx-[20px] flex items-center py-5"><div className="grid h-5 w-11 place-items-center">{SpinnerIcon ? <SpinnerIcon className="h-5 w-5 animate-spin text-zinc-400/60" /> : null}</div><div className="text-lg leading-tight opacity-80">{loadingLabel}</div></div> : hasError ? <div className="flex items-center px-[20px] py-5 leading-tight opacity-80"><div className="mr-2 grid h-[1.125rem] w-9 flex-shrink-0 place-items-center pl-1">{FerryIcon ? <FerryIcon className="h-[1.125rem] w-[1.125rem] text-zinc-400/60 dark:text-white" /> : null}</div><div>{errorLabel}</div></div> : message ? <div className="flex items-center px-[20px] py-5 leading-tight opacity-80"><div className="mr-2 grid h-[1.125rem] w-9 flex-shrink-0 place-items-center pl-1">{FerryIcon ? <FerryIcon className="h-[1.125rem] w-[1.125rem] text-zinc-400/60 dark:text-white" /> : null}</div><div>{message}</div></div> : trips.length ? trips.map(ferry => <LiveFerryRow key={ferry.key} ferry={ferry} FerryIcon={FerryIcon} LinkComponent={LinkComponent} RouteBadgeComponent={RouteBadgeComponent} />) : <div className="flex items-center px-[20px] py-5 leading-tight opacity-80"><div className="mr-2 grid h-[1.125rem] w-9 flex-shrink-0 place-items-center pl-1">{FerryIcon ? <FerryIcon className="h-[1.125rem] w-[1.125rem] text-zinc-400/60 dark:text-white" /> : null}</div><div>{emptyLabel}</div></div>}</div>;
    $[0] = FerryIcon;
    $[1] = LinkComponent;
    $[2] = RouteBadgeComponent;
    $[3] = SpinnerIcon;
    $[4] = emptyLabel;
    $[5] = errorLabel;
    $[6] = isLoading;
    $[7] = isValidating;
    $[8] = liveFerries;
    $[9] = loadingLabel;
    $[10] = stopNameById;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}